import Vue from 'vue';
import { addCache, getCache } from '@/api/brand-report.js';
const user = {
    state: {
        access_token: '', //token
        setlectBrandToCompare: [],
        merchantId: '', //商户id
        uid: '', //用户id
        selectBrand: '', //当前查看详情的品牌id
        isShowDataCompare: false, //数据对比模块开关
        equityBrandList: [], //当前商户权益品牌
        equityBrandObj: {
            compete_brand: [], //竞对
            cooperative_brand: [], //协同
            other_brand: [] //其他
        },
        equityBrandIconMap: {}, // 品牌code和icon的映射 {brandCode: icon}
        equityBrandCodeArr: [], // 权益品牌code数组，用于权限判断
        reportDataChange: true, // 品牌对比数据发生变化
        reportAllLoad: 0, // 品牌对比所有接口加载完成
        aroundData: [], // 周边数据
        aroundCity: {}, // 所选城市
        aroundRadius: '',
        aroundLifeData: [], // 周边数据
        insightData: {}, // 门店洞察
        insightCity: {}, // 所选城市
        takeoutData: [], //外卖数据
        takeoutAroundData: [], //外卖数据
        takeoutCity: {}, // 所选城市
        takeoutRadius: '',
        scanCodeLoginType: false, //扫码登录
        leftTableObj: {} //左侧导航数据
    },
    mutations: {
        SET_ACCESS_TOKEN: (state, access_token) => {
            state.access_token = access_token;
        },
        SET_SELECT_BRAND_TO_COMPARE: (state, data) => {
            state.setlectBrandToCompare = data;
        },
        SET_MERCHANT_ID: (state, data) => {
            state.merchantId = data;
        },
        SET_UID: (state, data) => {
            state.uid = data;
        },
        SET_IS_SHOW_DATA_COMPARE: (state, data) => {
            state.isShowDataCompare = data;
        },
        SET_EQUITY_BRAND_LIST: (state, data) => {
            state.equityBrandList = data;
        },
        SET_EQUITY_BRAND_OBJ: (state, data) => {
            state.equityBrandObj = data;
        },
        SET_EQUITY_BRAND_ICON_MAP: (state, data) => {
            state.equityBrandIconMap = data;
        },
        SET_EQUITY_BRAND_CODE_ARR: (state, data) => {
            state.equityBrandCodeArr = data;
        },
        SET_SELECT_BRAND: (state, data) => {
            state.selectBrand = data;
        },
        SET_LOCATION_SELECTION_OBJ: (state, data) => {
            state.locationSelectionObj = data;
        },
        SET_REPORT_DATA_CHANGE: (state, data) => {
            state.reportDataChange = data;
        },
        SET_REPORT_ALL_ADD: (state) => {
            state.reportAllLoad++;
        },
        SET_REPORT_ALL_LOAD: (state, data) => {
            state.reportAllLoad = data;
        },
        SET_AROUND_DATA: (state, data) => {
            state.aroundData = data.aroundData;
            state.aroundCity = data.aroundCity;
            state.aroundRadius = data.aroundRadius;
        },
        SET_AROUND_LIFE_DATA: (state, data) => {
            state.aroundLifeData = data;
        },
        SET_INSIGHT_DATA: (state, data) => {
            state.insightData = data.insightData;
            state.insightCity = data.insightCity;
        },
        SET_TAKEOUT_DATA: (state, data) => {
            state.takeoutData = data;
        },
        SET_TAKEOUT_AROUND_DATA: (state, data) => {
            state.takeoutAroundData = data.takeoutAroundData;
            state.takeoutCity = data.takeoutCity;
            state.takeoutRadius = data.takeoutRadius;
        },
        SET_SCAN_CODE_LOGIN_TYPE: (state, data) => {
            state.scanCodeLoginType = data;
        },
        SET_LEFT_TABLE_OBJ: (state, data) => {
            state.leftTableObj = data;
        },
        SET_LEFT_TABLE_OBJ_ITEM: (state, { code, item }) => {
            Vue.set(state.leftTableObj, code, item);
        }
    },
    actions: {
        brandAxios(context, payload) {
            //由于品牌对比数据在net-work-cli项目中也有使用 所以需要调用接口进行存储
            let data = {
                cacheData: JSON.stringify(payload)
            };
            addCache(data).then(() => {
                context.commit('SET_SELECT_BRAND_TO_COMPARE', payload);
            });
        },
        updateBrand(context) {
            //更新品牌对比数据
            getCache().then((res) => {
                context.commit('SET_SELECT_BRAND_TO_COMPARE', res ? JSON.parse(res) : []);
            });
        }
    },
    modules: {}
};
export default user;
